import ModelMappingValueOrigin from "~/models/mapping/modelMappingValueOrigin";
import ModelMappingOriginPaymentStepLineItem from "~/models/mapping/modelMappingOriginPaymentStepLineItem";
import PaymentStep from "../../../formability/form_builder/models/workflow/paymentStep";
import {
  PaymentLineItemInformationType, PaymentLineItemInformationTypeDisplay
} from "../../../formability/mappingBuilder/enums/payment-information-type";
import {RegexHelper} from "~/helpers/regexHelper";
import {NumberHelper} from "~/helpers/numberHelper";

export default class ModelMappingValueOriginPaymentStepLineItem extends ModelMappingValueOrigin<PaymentStep, ModelMappingOriginPaymentStepLineItem> {
  isIndexed: boolean = false
  isSinglePicklist: boolean = false
  isMultiPicklist: boolean = false
  isUploader: boolean = false
  // should match format in ModelMappingValueOriginPaymentStepLineItem.buildId
  static ID_FORMAT = new RegExp(`^(\\d+)__lineItem__(${RegexHelper.strings.clientId})$`)

  get origin(): PaymentStep {
    return this.modelMappingOrigin.origin
  }

  get stepClientId(): string {
    return this.modelMappingOrigin.stepClientId
  }

  get type(): PaymentLineItemInformationType {
    return NumberHelper.toIntOrNull(this.id)
  }

  get value() {
    return {
      label: ModelMappingValueOriginPaymentStepLineItem.buildLabel(this.origin, this.type)
    }
  }

  get valueType(): string {
    return ModelMappingValueOriginPaymentStepLineItem.buildLabelSuffix(this.origin, this.type)
  }

  static buildId(step: PaymentStep, type: PaymentLineItemInformationType): string {
    return type.toString()
  }

  static buildLabel(step: PaymentStep, type: PaymentLineItemInformationType): string {
    return PaymentLineItemInformationTypeDisplay[type].label
  }

  static buildLabelSuffix(step: PaymentStep, type: PaymentLineItemInformationType): string {
    return PaymentLineItemInformationTypeDisplay[type].type
  }
}